<template>
  <v-container fluid fill-height>
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-center">
        <div class="text-center mb-5">
          <v-icon class="display-4" color="grey">mdi-folder-open</v-icon>
        </div>
        <div class="headline font-weight-light">
          Nothing to report on yet!
        </div>
      </v-flex>
      <v-flex xs12 class="text-center">
        <router-link to="/campaigns/new">Create your first campaign</router-link>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {}
    },
    methods: {}
  }
</script>
